// extracted by mini-css-extract-plugin
export default {"vignette":"MapVignette_vignette__4Uu1G"};